<template>
  <v-row
    align="center"
    justify="center"
    class="ma-0"
  >
    <v-col
      cols="12"
      sm="8"
      md="4"
      lg="4"
      xl="3"
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col class="my-4">
          <v-img
            contain
            src="/img/header_logo.png"
            height="40px"
            alt="NetWorkT Team & Telekom Logo"
          />
        </v-col>
      </v-row>
      <v-card outlined>
        <ResendVerification />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Layout from '@/Layouts/Basic'
import ResendVerification from '@/Components/Auth/ResendVerification'

export default {
   metaInfo: { title: 'Verify E-Mail' },
   components: {
      ResendVerification
   },
   layout: (h, page) => h(Layout, [page]),
}
</script>

<style>

</style>
